import * as React from 'react';
import './compPagePromotion.scss';

export interface ICompPagePromotionProps {
    jobTitle: string;
}

const CompPagePromotion = (props: ICompPagePromotionProps): React.ReactElement => {
    const { jobTitle } = props;

    return (
        <div className="comp-page-promotion">
            <p className="comp-page-promotion__heading">Promotion</p>
            <p className="comp-page-promotion__job-title">{jobTitle}</p>
        </div>
    );
};

export default CompPagePromotion;
export { CompPagePromotion };